import { render, staticRenderFns } from "./PvHeader.vue?vue&type=template&id=27cf8533&scoped=true&"
import script from "./PvHeader.vue?vue&type=script&lang=js&"
export * from "./PvHeader.vue?vue&type=script&lang=js&"
import style0 from "./PvHeader.vue?vue&type=style&index=0&id=27cf8533&scoped=true&lang=css&"
import style1 from "./PvHeader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cf8533",
  null
  
)

export default component.exports